import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Notes from "./pages/Notes";
import NoteDetail from "./pages/NoteDetail";
import Test from "./pages/Test";
import TestCreate from "./pages/TestCreate";
import TestTake from "./pages/TestTake";
import CreatedTests from "./pages/CreatedTests";
import { NotesProvider } from "./context/NotesContext";
import { TestProvider } from "./context/TestContext";
import { AIErrorProvider } from "./ai/context/AIErrorContext";
import ErrorBoundary from "./components/ErrorBoundary";
import { ErrorProvider } from "./context/ErrorContext";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import TestResults from "./pages/TestResults";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import Profile from "./pages/Profile";
import LandingPage from "./pages/LandingPage";
import "./styles/animations.css";
import Payment from "./pages/Payment";
import SubscriptionSettings from "./pages/SubscriptionSettings";
import BillingSettings from "./pages/BillingSettings";
import Pricing from "./pages/Pricing";
// Protected Route wrapper
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("auth_token");
  if (!token) {
    // Store the intended destination
    sessionStorage.setItem("redirectTo", window.location.pathname);
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  return (
    <ErrorBoundary>
      <ErrorProvider>
        <AIErrorProvider>
          <NotesProvider>
            <TestProvider>
              <Routes>
                {/* Public routes */}
                <Route
                  path="/login"
                  element={
                    localStorage.getItem("auth_token") ? (
                      <Navigate to="/dashboard" replace />
                    ) : (
                      <Login />
                    )
                  }
                />
                <Route path="/auth/callback" element={<AuthCallback />} />

                {/* Protected routes */}
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/notes"
                  element={
                    <ProtectedRoute>
                      <Notes />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/notes/:id"
                  element={
                    <ProtectedRoute>
                      <NoteDetail />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/test"
                  element={
                    <ProtectedRoute>
                      <Test />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/test/create"
                  element={
                    <ProtectedRoute>
                      <TestCreate />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/test/take"
                  element={
                    <ProtectedRoute>
                      <TestTake />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/test/created"
                  element={
                    <ProtectedRoute>
                      <CreatedTests />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/test/results"
                  element={
                    <ProtectedRoute>
                      <TestResults />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/test/results/:resultId"
                  element={<TestResults />}
                />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/payment" element={<Payment />} />
                <Route
                  path="/settings/subscription"
                  element={
                    <ProtectedRoute>
                      <SubscriptionSettings />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/settings/billing"
                  element={
                    <ProtectedRoute>
                      <BillingSettings />
                    </ProtectedRoute>
                  }
                />
                <Route path="/pricing" element={<Pricing />} />

                {/* Default routes */}
                <Route path="/" element={<LandingPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </TestProvider>
          </NotesProvider>
        </AIErrorProvider>
      </ErrorProvider>
    </ErrorBoundary>
  );
}

export default App;
